<template>
  <v-container fluid grid-list-sm>
    <v-layout>
      <v-flex xs12 sm12 md6 sm6 class="align-center">
        <v-layout align-center column class="ma-0 pa-0">
          <v-flex class="pa-0">
            <v-img :src="contactImage" height="auto" width="200px">
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular indeterminate></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
            <v-progress-linear
              v-if="showProgress"
              color="info"
              height="10"
              :value="value"
            ></v-progress-linear>
          </v-flex>
        </v-layout>
        <v-layout justify-center class="mt-2" v-if="editmode">
          <input
            ref="pickCover"
            type="file"
            @change="getFile"
            style="display: none;"
          />
          <v-btn color="info" small @click="$refs.pickCover.click()"
            >Select</v-btn
          >
          <v-btn color="info" small type="submit" @click="submitImage"
            >Submit</v-btn
          >
          <v-btn v-if="buttonRemove" color="error" small @click="removeImage"
            >Delete</v-btn
          >
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    editmode: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showProgress: false,
      value: 0,
      buttonRemove: false,
      image: null,
      file: null
    };
  },
  methods: {
    getFile: async function(eventf) {
      var tgt = eventf.target || window.event.srcElement;
      let files = tgt.files;

      let self = this;
      if (FileReader && files && files.length) {
        var fr = new FileReader();
        fr.onload = function() {
          self.image = fr.result;
        };
        fr.readAsDataURL(files[0]);
      }
      this.file = tgt.files[0];
      this.processFile(this.file);
    },
    processFile: function(file) {
      console.log(file);
    }
  }
};
</script>
